'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _setDisplayName = require('recompose/setDisplayName');

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = require('recompose/wrapDisplayName');

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = require('recompose/createEagerFactory');

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function initState(getStateByProps, props) {
  if (typeof getStateByProps !== 'function') return getStateByProps;

  var stateValue = getStateByProps(props);
  return typeof stateValue === 'function' ? stateValue() : stateValue;
}

var withStateByProps = function withStateByProps(stateName, stateUpdaterName, getStateByProps) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);

    var WithStateByProps = function (_Component) {
      _inherits(WithStateByProps, _Component);

      function WithStateByProps(props) {
        _classCallCheck(this, WithStateByProps);

        var _this = _possibleConstructorReturn(this, (WithStateByProps.__proto__ || Object.getPrototypeOf(WithStateByProps)).call(this, props));

        _this.state = {
          stateValue: initState(getStateByProps, _this.props)
        };

        _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        };

        if (typeof getStateByProps === 'function') {
          _this.componentWillReceiveProps = function (nextProps) {
            var nextState = getStateByProps(nextProps, _this.props);
            if (nextState !== undefined) {
              _this.updateStateValue(nextState);
            }
          };
        }
        return _this;
      }

      _createClass(WithStateByProps, [{
        key: 'render',
        value: function render() {
          var _extends2;

          return factory(_extends({}, this.props, (_extends2 = {}, _defineProperty(_extends2, stateName, this.state.stateValue), _defineProperty(_extends2, stateUpdaterName, this.updateStateValue), _extends2)));
        }
      }]);

      return WithStateByProps;
    }(_react.Component);

    if (process.env.NODE_ENV !== 'production') {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withStateByProps'))(WithStateByProps);
    }
    return WithStateByProps;
  };
};

exports.default = withStateByProps;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/withStateByProps.js
// module id = 1276
// module chunks = 0